import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../shared/AppSettings';
import { tChartAccModel } from '../models/tChartAccModel';




@Injectable({
    providedIn: 'root'
})

export class tChartAccService {


    constructor(private http: HttpClient) { }

    baseurl: string = AppSettings.BaseURI;

    readonly pathName = '/tChartAccModels';

    getAllData() {
        return this.http.get<tChartAccModel[]>(this.baseurl + this.pathName);
    }

    getAllDataByAccCode(accCode: string) {
        return this.http.get<tChartAccModel[]>(this.baseurl + this.pathName + '/GetAllDataByAccCode/' + accCode);
    }

    addData(data: tChartAccModel) {
        return this.http.post(this.baseurl + this.pathName + '/' + 'Formatted', data);
      }

    deleteData(data: tChartAccModel) {
    return this.http.delete(this.baseurl + this.pathName + '/' + 'Formatted' + '/' + data.accCode);
    }

    updateData(data: tChartAccModel) {
    return this.http.put(this.baseurl + this.pathName  + '/' + 'Formatted' + '/' + data.accCode, data);
    }

}